export default __webpack_public_path__ + "static/media/Hangman3.7efe0cfa.svg";